export const DEFAULT = 'FULL_PAYMENT'
